var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 165,
    viewBox: "0 0 227 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 71,
    width: 69,
    height: 95,
    fill: "#BAE289"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 30,
    width: 69,
    height: 136,
    fill: "#99CF63"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    width: 69,
    height: 166,
    fill: "#77B248"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalline);
export default __webpack_public_path__ + "static/media/verticalline.80f0c167fdb1faf904b4bf53a83b5cdd.svg";
export { ForwardRef as ReactComponent };